module.exports = __webpack_public_path__ + "static/media/logo.88bddcd6.jpg";